import CrudBase from '../../../CrudBase';
import axios from '../../../../axios-common';

class CityApi extends CrudBase {

  search = (text) => axios.get(`${this.endpoint}/get-by?text=${text}`);

  defaultMethods = {
    search: this.search,
  }
};

const city = new CityApi('api/v1/city');

export default city.defaultMethods;
